import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const DoubleChevronRightIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="doubleChevronRight" ref={ref} {...props}>
    <path d="M11.76,18a.75.75,0,0,1-.52-1.29L16.1,12,11.24,7.31a.75.75,0,0,1,1-1.08l5.42,5.23a.73.73,0,0,1,.23.54.74.74,0,0,1-.23.54l-5.42,5.23A.77.77,0,0,1,11.76,18Zm-5,0a.75.75,0,0,1-.52-1.29L11.11,12,6.25,7.31a.75.75,0,1,1,1-1.08l5.42,5.23a.73.73,0,0,1,.23.54.74.74,0,0,1-.23.54L7.29,17.77A.77.77,0,0,1,6.77,18Z" />
  </Icon>
)) as IconWithRender;

DoubleChevronRightIcon.displayName = 'DoubleChevronRightIcon';
DoubleChevronRightIcon.renderIcon = (props) => (
  <DoubleChevronRightIcon {...props} />
);
export default DoubleChevronRightIcon;
